const LogoShort = () => (
	<svg width="24" height="24" viewBox="0 0 133 133" fill="none">
		<path
			d="M0 27C0 12.0883 12.0883 0 27 0H106C120.912 0 133 12.0883 133 27V106C133 120.912 120.912 133 106 133H27C12.0883 133 0 120.912 0 106V27Z"
			fill="#F02884"
		/>
		<path
			d="M49.8703 78.2325H42.674V46.0085C42.674 40.926 39.9381 38.1852 34.8508 38.1852H31.4878C26.4053 38.1852 23.6646 40.9212 23.6646 46.0085V86.9962C23.6646 92.0787 26.4006 94.8195 31.4878 94.8195H49.8703C54.9528 94.8195 57.6936 92.0835 57.6936 86.9962V86.0557C57.6936 80.9732 54.9576 78.2325 49.8703 78.2325Z"
			fill="white"
		/>
		<path
			d="M102.472 38.1852H98.1682C93.708 38.1852 90.8152 40.2183 89.1717 44.365L82.8352 60.6337L76.5795 44.365C74.936 40.1422 72.0432 38.1852 67.583 38.1852H63.517C57.494 38.1852 55.1475 41.9425 57.7267 47.4145L73.4492 80.1895V87.4617C73.4492 92.1547 76.1852 94.8147 81.2725 94.8147H84.5595C89.642 94.8147 92.3827 92.0787 92.3827 86.9915V80.1847L108.262 47.4097C110.922 42.0185 108.495 38.1852 102.472 38.1852Z"
			fill="white"
		/>
	</svg>
);

export default LogoShort;
